import { Crop } from 'react-image-crop';

interface OnImageLoadProps {
  aspect: number;
  setCrop: React.Dispatch<React.SetStateAction<Crop | undefined>>;
}

const onImageLoad = (
  { currentTarget }: React.SyntheticEvent<HTMLImageElement>,
  { aspect, setCrop }: OnImageLoadProps
) => {
  if (aspect) {
    const { width } = currentTarget;
    const cropWidth = width;
    const cropHeight = (cropWidth * 9) / 21;

    setCrop({
      unit: 'px',
      x: 0,
      y: 0,
      width: cropWidth,
      height: cropHeight,
    });
  }
};
export default onImageLoad;
